import { create } from "zustand";
import { persist } from "zustand/middleware";
import { SidebarStore } from "@/types";
import { isMobile } from "@/lib/is-mobile";

const useSidebarStore = create<SidebarStore>()(
  persist(
    (set, get) => ({
      isOpen: !isMobile(), // Mobil cihazda false, diğerlerinde true
      collapsedGroups: {},
      showSidebarHelp: false,
      selectedFilter: "all",
      toggleSidebar: () => set((state) => ({ isOpen: !state.isOpen })),
      setSidebarOpen: (open: boolean) => set({ isOpen: open }),
      toggleGroup: (groupName: string) =>
        set((state) => ({
          collapsedGroups: {
            ...state.collapsedGroups,
            [groupName]: !state.collapsedGroups[groupName],
          },
        })),
      collapseAllGroups: () => {
        const currentGroups = get().collapsedGroups;
        const allCollapsed = Object.keys(currentGroups).reduce((acc, key) => {
          acc[key] = true;
          return acc;
        }, {} as Record<string, boolean>);
        set({ collapsedGroups: allCollapsed });
      },
      expandAllGroups: () => {
        const currentGroups = get().collapsedGroups;
        const allExpanded = Object.keys(currentGroups).reduce((acc, key) => {
          acc[key] = false;
          return acc;
        }, {} as Record<string, boolean>);
        set({ collapsedGroups: allExpanded });
      },
      setShowSidebarHelp: (show: boolean) => set({ showSidebarHelp: show }),
      setSelectedFilter: (filter: "all" | "recent" | "favorites") =>
        set({ selectedFilter: filter }),
    }),
    {
      name: "sidebar-storage",
      partialize: (state) => ({
        isOpen: state.isOpen,
        collapsedGroups: state.collapsedGroups,
        selectedFilter: state.selectedFilter,
      }),
      onRehydrateStorage: () => () => {
        const store = useSidebarStore.getState();
        store.setSidebarOpen(!isMobile());
      },
    }
  )
);

// Ekran boyutu değişikliklerini dinle
if (typeof window !== "undefined") {
  let resizeTimeout: number;
  window.addEventListener("resize", () => {
    // Debounce uygula
    clearTimeout(resizeTimeout);
    resizeTimeout = window.setTimeout(() => {
      const store = useSidebarStore.getState();
      // Mobil moddan çıkıldığında sidebar'ı aç, mobile geçildiğinde kapat
      store.setSidebarOpen(!isMobile());
    }, 100);
  });
}

export default useSidebarStore;
